module.exports = __webpack_public_path__ + "img/hotdog-top-ma001.47700734.jpg";